export default {
  LATESET_REFERRER_SESSIONSTORAGE_KEY: 'latest_referrer' as const,
}
